import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ddc95846"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "page__header container"
}
const _hoisted_2 = { class: "page__title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "page__info"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Население", -1))
const _hoisted_7 = { class: "page__value" }
const _hoisted_8 = {
  key: 2,
  class: "page__info"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Плотность", -1))
const _hoisted_11 = { class: "page__value" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "container" }
const _hoisted_14 = {
  key: 0,
  class: "page__content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sidebar = _resolveComponent("sidebar")!
  const _component_report_year_select = _resolveComponent("report-year-select")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.sidebarList && _ctx.sidebarList.length)
      ? (_openBlock(), _createBlock(_component_sidebar, {
          key: 0,
          list: _ctx.sidebarList,
          onOpened: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sidebarOpened = true)),
          onClosed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sidebarOpened = false))
        }, null, 8, ["list"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "page",
      style: _normalizeStyle({
        paddingTop: _ctx.paddingTop
      })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["page__main", {
	        'fixed': _ctx.fixed,
	        'fixed--closed': !_ctx.sidebarOpened,
	        'fixed--full-width': !_ctx.sidebarList.length
	      }])
      }, [
        (_ctx.showHeader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("h2", _hoisted_2, [
                _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
                (_ctx.subtitle)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(': ' + _ctx.subtitle), 1))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.hasYearSelect)
                ? (_openBlock(), _createBlock(_component_report_year_select, { key: 0 }))
                : _createCommentVNode("", true),
              (_ctx.population)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("img", {
                      src: require('@/shared/assets/icons/population.svg'),
                      alt: "population"
                    }, null, 8, _hoisted_5),
                    _hoisted_6,
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.normalizePopulation) + " чел. ", 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.populationDensity)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: require('@/shared/assets/icons/density.svg'),
                      alt: "density"
                    }, null, 8, _hoisted_9),
                    _hoisted_10,
                    _createElementVNode("span", _hoisted_11, " ≈" + _toDisplayString(+_ctx.populationDensity.toFixed() || 1) + " чел./км² ", 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.customLink.url)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 3,
                    href: _ctx.customLink.url,
                    target: "_blank",
                    style: {"position":"absolute","right":"var(--container-padding)"},
                    rel: "noreferrer nofollow noopener"
                  }, [
                    _createVNode(_component_el_button, {
                      link: "",
                      style: {"font-size":"0.7rem"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.customLink.text), 1)
                      ]),
                      _: 1
                    })
                  ], 8, _hoisted_12))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_13, [
        (_ctx.$slots.default)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
      ])
    ], 4)
  ]))
}